'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	type: 'SUB_MENU_DROPDOWN',
	name: 'Sub menu dropdown',
	allowedSections: ['footer', 'header', 'main'],
	disallowedChildren: ['*'],
	category: 'Nav',
	props: [{
		name: 'iconClosed',
		inputType: 'icon',
		label: 'Choose icon to expand dropdown',
		default: false
	}, {
		name: 'iconOpen',
		inputType: 'icon',
		label: 'Choose icon to collapse dropdown',
		default: false
	}, {
		name: 'iconSize',
		inputType: 'text',
		label: 'Size on icons',
		default: '1em'
	}, {
		name: 'showHiddenCategories',
		inputType: 'checkbox',
		label: 'Show hidden categories',
		default: false
	}, {
		name: 'includeParent',
		inputType: 'checkbox',
		label: 'Inlcude parent',
		default: false
	}, {
		name: 'parentLinkPrefix',
		inputType: 'text',
		label: 'Parent link prefix',
		default: 'All '
	}, {
		name: 'siblingFallback',
		inputType: 'checkbox',
		label: 'Fall back on siblings',
		default: false
	}],
	hiddenProps: (0, _applyConfigs2.default)(['htmlclass'])
};